import { Box, Chip, Link, Paper, Stack, Typography } from "@mui/material";
import Grid from "@mui/material/Grid";
import PropTypes from "prop-types";
import { BID_STATUS } from "../../util/bid/bidConstants";
import { getShiftDate } from "../../util/dateTimeFormatter";
import BidScheduledStatusChip from "../bid/BidScheduledStatusChip";
import BidTimer from "../bid/BidTimer";

const DashboardAdminBid = (props) => {
  const renderOpenBid = () => {
    return (
      <Link
        href={`#/manageBid/${props.bid.referenceNumber}`}
        underline="hover"
        color="inherit"
        sx={{
          textDecoration: "none",
          "&:hover": { textDecoration: "underline" },
          "& *": { textDecoration: "inherit" },
        }}
      >
        <Paper
          variant="outlined"
          sx={{
            marginBottom: "8px",
            padding: "10px",
            borderRadius: "10px",
          }}
        >
          <Grid container>
            <Grid item xs={3}>
              <Stack direction="column" alignItems="flex-start" spacing={0.5}>
                <Chip
                  label={props.bid.bidType}
                  sx={{
                    borderRadius: "5px",
                    bgcolor: "secondary.swaLightestBlue",
                    alignSelf: "flex-start",
                    width: "auto",
                  }}
                />
                <Typography variant="body2" sx={{ textAlign: "left", padding: "5px" }}>
                  {props.bid.workgroup}
                </Typography>
              </Stack>
            </Grid>
            <Grid item xs={9}>
              <Stack direction="column" sx={{ textAlign: "left" }}>
                <Stack direction="row">
                  <Stack direction="column">
                    <Typography
                      variant="body2"
                      sx={{
                        fontWeight: "bold",
                        fontSize: "10px",
                        color: "secondary.swaDarkBlue",
                        width: "10vw",
                      }}
                    >
                      BID WINDOW
                    </Typography>
                    <Typography variant="body2" sx={{ width: "10vw" }}>
                      {getShiftDate(props.bid.windowStartDate)} - {getShiftDate(props.bid.windowEndDate)}{" "}
                    </Typography>
                  </Stack>
                  <Stack direction="column" sx={{ paddingLeft: "2rem" }}>
                    <Typography
                      variant="body2"
                      sx={{
                        fontWeight: "bold",
                        fontSize: "10px",
                        color: "secondary.swaDarkBlue",
                        width: "10vw",
                      }}
                    >
                      BID EFFECTIVE DATES
                    </Typography>
                    <Typography variant="body2" sx={{ width: "10vw" }}>
                      {getShiftDate(props.bid.schedStartDate)} - {getShiftDate(props.bid.schedEndDate)}{" "}
                    </Typography>
                  </Stack>
                </Stack>
                {props.bid.bidName && (
                  <>
                    <Typography
                      variant="body2"
                      sx={{ fontWeight: "bold", fontSize: "10px", color: "secondary.swaDarkBlue" }}
                    >
                      BID NAME
                    </Typography>
                    <Typography variant="body2">{props.bid.bidName}</Typography>
                  </>
                )}
                <Typography
                  variant="body2"
                  component="span"
                  sx={{
                    color: "primary.swaRed",
                    fontWeight: "bold",
                    display: "inline-block",
                    textAlign: "right",
                  }}
                >
                  <BidTimer
                    windowDates={[props.bid.windowStartDate, props.bid.windowEndDate]}
                    station={props.bid.station}
                  />
                </Typography>
              </Stack>
            </Grid>
          </Grid>
        </Paper>
      </Link>
    );
  };

  const renderPendingBid = () => {
    return (
      <Link
        href={`#/manageBid/${props.bid.referenceNumber}`}
        underline="hover"
        color="inherit"
        sx={{
          textDecoration: "none",
          "&:hover": { textDecoration: "underline" },
          "& *": { textDecoration: "inherit" },
        }}
      >
        <Paper
          variant="outlined"
          sx={{
            marginBottom: "8px",
            padding: "10px",
            borderRadius: "10px",
          }}
        >
          <Grid container>
            <Grid item xs={3}>
              <Stack direction="column" alignItems="flex-start" spacing={0.5}>
                <Chip
                  label={props.bid.bidType}
                  sx={{
                    borderRadius: "5px",
                    bgcolor: "secondary.swaLightestBlue",
                    alignSelf: "flex-start",
                    width: "auto",
                  }}
                />
                <Typography variant="body2" sx={{ textAlign: "left", padding: "5px" }}>
                  {props.bid.workgroup}
                </Typography>
              </Stack>
            </Grid>
            <Grid item xs={9}>
              <Stack direction="column" sx={{ textAlign: "left" }}>
                <Stack direction="row">
                  <Stack direction="column">
                    <Typography
                      variant="body2"
                      sx={{
                        fontWeight: "bold",
                        fontSize: "10px",
                        color: "secondary.swaDarkBlue",
                        width: "10vw",
                      }}
                    >
                      BID WINDOW
                    </Typography>
                    <Typography variant="body2" sx={{ width: "10vw" }}>
                      {props.bid.windowStartDate && props.bid.windowEndDate
                        ? `${getShiftDate(props.bid.windowStartDate)} -
                                                ${getShiftDate(props.bid.windowEndDate)}`
                        : "-"}
                    </Typography>
                  </Stack>
                  <Stack direction="column" sx={{ paddingLeft: "2rem" }}>
                    <Typography
                      variant="body2"
                      sx={{
                        fontWeight: "bold",
                        fontSize: "10px",
                        color: "secondary.swaDarkBlue",
                        width: "10vw",
                      }}
                    >
                      BID EFFECTIVE DATES
                    </Typography>
                    <Typography variant="body2" sx={{ width: "10vw" }}>
                      {props.bid.schedStartDate && props.bid.schedEndDate
                        ? `${getShiftDate(props.bid.schedStartDate)} -
                                                ${getShiftDate(props.bid.schedEndDate)}`
                        : "-"}
                    </Typography>
                  </Stack>
                </Stack>
                {props.bid.bidName ? (
                  <Stack>
                    <Typography
                      variant="body2"
                      sx={{ fontWeight: "bold", fontSize: "10px", color: "secondary.swaDarkBlue" }}
                    >
                      BID NAME
                    </Typography>
                    <Stack direction="row" alignItems="center" sx={{ mt: "-8px" }}>
                      <Typography variant="body2" noWrap sx={{ flexGrow: 1 }}>
                        {props.bid.bidName}
                      </Typography>
                      <BidScheduledStatusChip scheduledStatus={props.bid.scheduledStatus} />
                    </Stack>
                  </Stack>
                ) : (
                  <Box sx={{ mt: "5px", alignSelf: "flex-end" }}>
                    <BidScheduledStatusChip scheduledStatus={props.bid.scheduledStatus} />
                  </Box>
                )}
              </Stack>
            </Grid>
          </Grid>
        </Paper>
      </Link>
    );
  };

  const renderClosedBid = () => {
    return (
      <Link
        href={`#/manageBid/${props.bid.referenceNumber}`}
        underline="hover"
        color="inherit"
        sx={{
          textDecoration: "none",
          "&:hover": { textDecoration: "underline" },
          "& *": { textDecoration: "inherit" },
        }}
      >
        <Paper
          variant="outlined"
          sx={{
            marginBottom: "8px",
            padding: "10px",
            borderRadius: "10px",
          }}
        >
          <Grid container>
            <Grid item xs={3}>
              <Stack direction="column" alignItems="flex-start" spacing={0.5}>
                <Chip
                  label={props.bid.bidType}
                  sx={{
                    borderRadius: "5px",
                    bgcolor: "secondary.swaLightestBlue",
                    alignSelf: "flex-start",
                    width: "auto",
                  }}
                />
                <Typography variant="body2" sx={{ textAlign: "left", padding: "5px" }}>
                  {props.bid.workgroup}
                </Typography>
              </Stack>
            </Grid>
            <Grid item xs={9}>
              <Stack direction="column" sx={{ textAlign: "left" }}>
                <Stack direction="row">
                  <Stack direction="column">
                    <Typography
                      variant="body2"
                      sx={{
                        fontWeight: "bold",
                        fontSize: "10px",
                        color: "secondary.swaDarkBlue",
                        width: "10vw",
                      }}
                    >
                      BID WINDOW
                    </Typography>
                    <Typography variant="body2" sx={{ width: "10vw" }}>
                      {getShiftDate(props.bid.windowStartDate)} - {getShiftDate(props.bid.windowEndDate)}{" "}
                    </Typography>
                  </Stack>
                  <Stack direction="column" sx={{ paddingLeft: "2rem" }}>
                    <Typography
                      variant="body2"
                      sx={{
                        fontWeight: "bold",
                        fontSize: "10px",
                        color: "secondary.swaDarkBlue",
                        width: "10vw",
                      }}
                    >
                      BID EFFECTIVE DATES
                    </Typography>
                    <Typography variant="body2" sx={{ width: "10vw" }}>
                      {getShiftDate(props.bid.schedStartDate)} - {getShiftDate(props.bid.schedEndDate)}{" "}
                    </Typography>
                  </Stack>
                </Stack>
                {props.bid.bidName && (
                  <>
                    <Typography
                      variant="body2"
                      sx={{ fontWeight: "bold", fontSize: "10px", color: "secondary.swaDarkBlue" }}
                    >
                      BID NAME
                    </Typography>
                    <Typography variant="body2">{props.bid.bidName}</Typography>
                  </>
                )}
                <Typography
                  variant="body2"
                  component="span"
                  sx={{
                    color: "primary.swaRed",
                    fontWeight: "bold",
                    display: "inline-block",
                    textAlign: "right",
                  }}
                >
                  <BidTimer
                    windowDates={[props.bid.windowStartDate, props.bid.windowEndDate]}
                    station={props.bid.station}
                  />
                </Typography>
              </Stack>
            </Grid>
          </Grid>
        </Paper>
      </Link>
    );
  };

  if (props.bid.status === BID_STATUS.OPEN) {
    return renderOpenBid();
  } else if (props.bid.status === BID_STATUS.PENDING) {
    return renderPendingBid();
  } else if (props.bid.status === BID_STATUS.CLOSED) {
    return renderClosedBid();
  }
};

DashboardAdminBid.propTypes = {
  bid: PropTypes.object.isRequired,
};

export default DashboardAdminBid;
